import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./homepage.scss";
import FsLightbox from "fslightbox-react";
//swiper imports
import { Navigation, Autoplay, Pagination, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

//components
import RightArrowButton from "../../components/RightArrowButton/RightArrowButton";
import LeftArrowButton from "../../components/LeftArrowButton/LeftArrowButton";
import Loader from "../../components/Loader/Loader";

//hooks
import useWindowDimensions from "../../hooks/useWindowDimensions";

//images import
import { ReactComponent as Fbgrey } from "../../images/homepage/fb-grey.svg";
import { ReactComponent as Instagrey } from "../../images/homepage/insta-grey.svg";
import { ReactComponent as Linkgrey } from "../../images/homepage/link-grey.svg";
import { ReactComponent as Twiitergrey } from "../../images/homepage/twiiter-grey.svg";
import { ReactComponent as Youtubegrey } from "../../images/homepage/youtube-grey.svg";
import pintrst from "../../images/homepage/pintrst.svg";
// import { ReactComponent as Pintrstgrey } from "../../images/homepage/pintrst.svg";
import { ReactComponent as HoverRightArrow } from "../../images/homepage/hover-right-arrow.svg";
// import bannerimg from "../../images/homepage/bannerimg.png";
import aboutSmallimg from "../../images/homepage/about-smallimg.png";
import playicon from "../../images/homepage/playicon.svg";
import directorimage from "../../images/homepage/directorimage.jpg";
// import buisnessimg1 from "../../images/homepage/buisnessimg1.png";
// import buisnessimg2 from "../../images/homepage/buisnessimg2.png";
// import brandimg1 from "../../images/homepage/brandimg1.png";
// import brandimg2 from "../../images/homepage/brandimg2.png";
// import newsimg1 from "../../images/homepage/newsimg1.png";
import aboutusbelowbanner from "../../images/homepage/aboutusbelowbanner.jpg";
import investorGraph from "../../images/homepage/investor-graph.png";
import instaimg1 from "../../images/homepage/instaimg1.png";
import instaimg2 from "../../images/homepage/instaimg2.png";
import {
  quoteComma,
  selectdropdownarrow,
  stockdown,
  stockup,
} from "../../images";
import {
  useGetMediasData,
  useGetOurBrandsData,
  useGetOurBusinessData,
  useGetSliderData,
  useGetSusData,
} from "../../hooks/useGetHomepageData";
import {
  businessImageUrl,
  sliderImageUrl,
  brandImageUrl,
  susBlocksImageUrl,
} from "../../helpers/utils";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import axios from "axios";
import config from "../../config/config";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
// import { Pagination } from "@mui/material";

gsap.registerPlugin(ScrollTrigger);
const ourBusinessBreakpoints = {
  0: {
    slidesPerView: 1.05,
  },
  345: {
    slidesPerView: 1.2,
  },
  767: {
    slidesPerView: 2.6,
  },
  1193: {
    slidesPerView: 3.8,
  },
  1280: {
    slidesPerView: 4.1,
  },
  1500: {
    slidesPerView: 4,
  },
  1541: {
    slidesPerView: 3.6,
  },
  1800: {
    slidesPerView: 4,
  },
  1921: {
    slidesPerView: 4.1,
  },
};
const sustainabilityBreakpoints = {
  0: {
    slidesPerView: 1.3,
    spaceBetween: 20,
  },
  767: {
    slidesPerView: 1.7,
    spaceBetween: 0,
  },
  992: {
    slidesPerView: 2.2,
  },
  1050: {
    slidesPerView: 2.7,
  },
  1540: {
    slidesPerView: 2.5,
  },
  1930: {
    slidesPerView: 2.9,
  },
};

// const bannerImagesArr = [bannerimg, bannerimg, bannerimg];

// const ourBusinessData = [
//   {
//     img: buisnessimg1,
//     title: "UCO Denim",
//   },
//   {
//     img: buisnessimg2,
//     title: "Realty",
//   },
//   {
//     img: buisnessimg1,
//     title: "UCO Denim",
//   },
//   {
//     img: buisnessimg2,
//     title: "Lifestyle",
//   },
//   {
//     img: buisnessimg1,
//     title: "Condumer Care",
//   },
//   {
//     img: buisnessimg2,
//     title: "Realty",
//   },
//   {
//     img: buisnessimg1,
//     title: "UCO Denim",
//   },
//   {
//     img: buisnessimg2,
//     title: "Realty",
//   },
// ];

// const ourBrandsData = [
//   {
//     tabName: "Raymond",
//     slideList: [
//       {
//         img: brandimg1,
//       },
//       {
//         img: brandimg2,
//       },
//       {
//         img: brandimg1,
//       },
//       {
//         img: "https://dummyimage.com/366x361/54was2",
//       },
//     ],
//   },
//   {
//     tabName: "Raymond Apparel",
//     slideList: [
//       {
//         img: brandimg1,
//       },
//       {
//         img: brandimg1,
//       },
//       {
//         img: brandimg2,
//       },
//     ],
//   },
//   {
//     tabName: "Consumer Care",
//     slideList: [
//       {
//         img: brandimg1,
//       },
//       {
//         img: brandimg2,
//       },
//       {
//         img: brandimg1,
//       },
//     ],
//   },
//   {
//     tabName: "Raymond Realty",
//     slideList: [
//       {
//         img: brandimg2,
//       },
//       {
//         img: brandimg1,
//       },
//       {
//         img: brandimg2,
//       },
//       {
//         img: brandimg1,
//       },
//     ],
//   },
// ];

// const newsAndMediaData = [
//   {
//     img: newsimg1,
//     title: "Raymond fine fabric",
//     desc: "Being a vertically and horizontally integrated manufacturer of",
//   },
//   {
//     img: newsimg1,
//     title: "Raymond fine fabric",
//     desc: "Being a vertically and horizontally integrated manufacturer of",
//   },
//   {
//     img: newsimg1,
//     title: "Raymond fine fabric",
//     desc: "Being a vertically and horizontally integrated manufacturer of",
//   },
// ];

// const susData = [
//   {
//     img: buisnessimg1,
//     title: "Content 01",
//   },
//   {
//     img: buisnessimg2,
//     title: "Content 02",
//   },
//   {
//     img: buisnessimg1,
//     title: "Content 03",
//   },
// ];

const Homepage = () => {
  const { width } = useWindowDimensions();
  const bannerEl = useRef();
  // const q = gsap.utils.selector(bannerEl);
  const [ourBrandIndex, setOurBrandIndex] = useState(0);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [vidLink, setVidLink] = useState("");
  const [stock, setStock] = useState({});
  const { isSliderLoading, sliderData } = useGetSliderData();
  let { isOurBusinessLoading, businessData } = useGetOurBusinessData();
  const { isOurBrandsLoading, brandsData } = useGetOurBrandsData();
  const { isMediaLoading, mediaData } = useGetMediasData();
  const { isSusLoading, susDataArr } = useGetSusData();

  const [instapost, setinstapost] = useState([]);
  let insta_api = config.insta_api;
  let insta_token = config.insta_token;
  let insta_limit = 12;
  let insta_fields =
    "id,media_type,media_url,username,timestamp,caption,permalink,thumbnail_url";

  const brandsDataArr = brandsData?.data?.data;


  const handleImageWrapperClick = (videoLink) => {
    setIsVideoModalOpen(!isVideoModalOpen);
    setVidLink(videoLink);
  };

  const fetchStock = async () => {
    try {
      const {
        data: { data },
      } = await axios({
        method: "GET",
        url: "https://priceapi.moneycontrol.com/pricefeed/bse/equitycash/R",
      });
      setStock(data);
      // setIsLoader(false);
    } catch (err) {
      console.log("stock error:-", err);
      setStock({});
      // setIsLoader(false);
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  useLayoutEffect(() => {
    // const el = document.querySelectorAll(".inner_span");
    // const spanArr = Array.from(el);
    // if (spanArr.length > 0) {
    //   const animName = "letterAnim";
    //   let animDelay = 0;
    //   spanArr.forEach((spanEl) => {
    //     spanEl.style.animation = `${animName} 0.5s linear ${animDelay}s forwards`;
    //     animDelay += 0.1;
    //   });
    // }
    // if (width > 1279) {
    // gsap.to(q(".banner_slides_wrapper"), {
    //   // scaleX: 1,
    //   width: "100%",
    //   scrollTrigger: {
    //     trigger: q(".banner_slides_wrapper"),
    //     start: "top 40%",
    //     end: "top 10%",
    //     scrub: true,
    //   },
    // });
    // }
  }, [
    isSliderLoading,
    isOurBusinessLoading,
    isOurBrandsLoading,
    isMediaLoading,
    isSusLoading,
  ]);

  const fetchInstaPost = async () => {
    try {
      const response = await axios.get(insta_api, {
        params: {
          fields: insta_fields,
          access_token: insta_token,
          limit: insta_limit,
        },
      });

      const { data } = response;

      if (data) {
        setinstapost(data.data);
      }
    } catch (error) {
      console.log("insta error", error.response);
    }
  };

  useEffect(() => {
    fetchInstaPost();
  }, []);

  useEffect(() => { }, [brandsDataArr]);
  const instapostlist = instapost.length
    ? instapost.map((data, key) => {
      if (data.media_type == "IMAGE") {
        return (
          // <figure className="swiper-slide" key={key}>
          //   <a href={data.permalink} target="_blank">
          //     <img
          //       src={
          //         data.media_type == "VIDEO"
          //           ? data.thumbnail_url
          //           : data.media_url
          //       }
          //       alt="Laxmi Instagram media"
          //       loading="lazy"
          //       className="instaimg"
          //     />
          //   </a>
          // </figure>

          <SwiperSlide>
            <a href={data.permalink} target="_blank">
              <img
                src={
                  data.media_type == "VIDEO"
                    ? data.thumbnail_url
                    : data.media_url
                }
                alt={data.caption}
                className="instaimg"
                loading="lazy"
                width={450}
                height={450}
              />
            </a>
          </SwiperSlide>
        );
      }
    })
    : null;

  //logical functions
  const handleBrandTabChange = (e) => {
    const brandIndexId = e.target.selectedOptions[0].dataset.brandindexid;
    setOurBrandIndex(brandIndexId);
  };

  // dom appending functions
  const bannerImgList = sliderData?.data?.data?.map(
    ({ image, type, thumbnail, url }, i) => (
      <SwiperSlide key={i}>
        {type === "image" ? (
          <img
            src={sliderImageUrl + image}
            alt="Banner"
            className="bannerimg"
            width={1631}
            height={670}
          />
        ) : (
          <figure
            className="bannerimg_wrapper"
            onClick={() => handleImageWrapperClick(url)}
          >
            <img
              src={sliderImageUrl + thumbnail}
              alt="Banner"
              className="bannerimg"
              width={1631}
              height={670}
            />
            <img src={playicon} alt="play icon" className="playicon" />
          </figure>
        )}
      </SwiperSlide>
    )
  );

  const ourBusinessList = businessData?.data?.data?.map(
    ({ title, image, _id, website }, i) => (
      <SwiperSlide key={i}>
        <Link to={website} state={{ boxId: _id }}>
          <div className="business_box">
            <img
              src={businessImageUrl + image}
              alt="Our business"
              loading="lazy"
              width={425}
              height={415}
              className="businessimg"
            />
            <HoverRightArrow className="circle_right_arrow" />
            <span className="business_text">{title}</span>
          </div>
        </Link>
      </SwiperSlide>
    )
  );
  let BD = [
    {
      "_id": "62c08e71838e7c12e3b2c81c",
      "title": "Raymond REALTY",
      "slug": "raymond-realty",
      "description": "<p>Since 1925, Raymond has been synonymous with Trust, Quality and Excellence. Raymond REALTY&rsquo;s focus is clear and absolute &ndash; to Go Beyond real estate conventions. To introduce a new standard of living that pushes the envelope on every aspect &ndash; construction quality, design aesthetic and comfort feasibility. We bring you elegant modern spaces, pleasant ambience and a range of exclusive amenities &ndash; making it a living experience unlike any other. And to ensure this, we always Go Beyond ourselves.</p>",
      "image": "167326161675416730140792003rd slide.jpg",
      "createdAt": "2022-07-02T18:29:05.258Z",
      "updatedAt": "2023-01-09T13:39:27.040Z",
      "__v": 0,
      "sort_order": 2,
      "brands": [
        {
          "_id": "62e004e09fe9a117cb3ce9c4",
          "title": "Ten X Habitat",
          "description": "<p>Ten X HABITAT is a thriving gated community which will elevate the benchmark of living standards. It is designed taking into account the principles of sustainability, modern architecture and contemporary design. The project is centrally located at Pokhran Road in Thane. It enjoys proximity to some of the best schools, hospitals, restaurants, malls, retail outlets, etc., whilst being well-connected to Eastern Express Highway, Ghodbunder Road and the Mumbai-Nashik Highway. Ten X HABITAT is a culmination of exquisite imagination and planning, designed keeping the future of human living in mind. It celebrates a new way of living &ndash; calm, carefree and comfortable. All the amenities and services here aim to enhance your experience by taking you beyond the essentials.</p>",
          "image": "16717996751541.jpg",
          "website": "https://www.raymondrealty.in/projects/ten-x-habitat/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 1,
          "createdAt": "2022-07-26T15:14:40.640Z",
          "updatedAt": "2023-01-06T12:36:36.314Z",
          "__v": 0
        },
        {
          "_id": "62e005019fe9a117cb3ce9c8",
          "title": "The Address by GS",
          "description": "<p>STEP INTO A CREATION</p>\r\n<p>#LIKE NO OTHER</p>\r\n<p>Welcome to the finest life that Raymond Realty has to offer - The Address by GS. My ode to elevated living, exclusively for you. Take a moment as you scroll through everything of life worth living. Savour every second of life \"like no other\" and enjoy my signature lifestyle as the true connoisseur of class.</p>\r\n<p>- Gautam Singhania, Chairman &amp; Managing Director &ndash; Raymond Limited</p>\r\n<p><strong>A LIFE</strong></p>\r\n<p><strong>#LIKE NO OTHER</strong></p>\r\n<p>It's a home for those who've made living 'a good life' a habit. It's a lifestyle suited for those who seek balance and substance. It's a life with just the right hint of exclusivity. Unimaginably well thought out and unapologetically modern, it's everything that is The Address by GS. It's an address that envelopes you in a world of convenience. With its uniquely advantageous location, it lies in the heart of growth &amp; commerce, be it malls, hospitals or top-class schools. Make the most of the easy access to all prime locations in the city and yet live tucked away into exclusivity. Sprawling across ~3 acres, this gated estate spell sophistication with 3,4,5 &amp; 6 bed residences. The stunning elevation of the twin towers, surrounded by manicured gardens, will instantly bring you feelings of unparalleled bliss. The motif of elevated living remains central to this development, be it on the ground, podium or even at clubhouse levels. At The Address by GS, you can expect to be delighted by a host of recreational amenities that rival the best in the city. A whooping 45000 sqft of clubhouse space brings alive the most modern yet classy club experience. It&rsquo;s packed with thoughtful and top-notch facilities to take you beyond the mere ornamental benefits. Our signature 3 &amp; 4 bed apartments and limited edition 5 &amp; 6 bed apartments are the definitions of expansiveness. The largest of their kind in Thane, these residences instantly feel like home with the upscale design, familiar comforts &amp; hand-picked personalization.</p>",
          "image": "16717997177282.jpg",
          "website": "https://www.raymondrealty.in/projects/the-address-by-gautam-singhania/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 2,
          "createdAt": "2022-07-26T15:15:13.013Z",
          "updatedAt": "2023-01-06T12:37:24.630Z",
          "__v": 0
        },
        {
          "_id": "649984bd144676734e6c262b",
          "title": "TEN X ERA",
          "description": "<p>At Raymond Realty, staying ahead is a quest. To constantly push the boundaries. To be on the cutting edge of style. To be the trendsetter. Experience what it is like to live miles ahead of time. Experience the new Era in living with Ten X Era. Offering a mix of intelligent design, smart use of space, and a futuristic lifestyle. Located next to Viviana Mall and closer to nearly every aspect of today&rsquo;s fast-paced life.</p>\r\n<p>TenX Era does a phenomenal job of setting the standard for the times to come with its mix of intelligent design, smart use of space and futuristic lifestyle. For the few who get to call it home, it tells the world more than just where they live. It tells them they live ahead of time. And miles ahead of everything that defines the good life.</p>\r\n<p>At 26,500 sq.ft., the well-appointed clubhouse has what it takes to be a destination on its own. But what it does remarkably well, is that it offers a new perspective on how socialising can be far ahead. Invite a few of your close friends for a game of baddy on the indoor court or organise a private screening in the mini-theater. The possibilities are endless.</p>",
          "image": "1687782589682TenX Era-01.jpg",
          "website": "https://raymondrealty.in/projects/ten-x-era/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 3,
          "createdAt": "2023-06-26T12:29:49.727Z",
          "updatedAt": "2023-06-26T12:40:36.330Z",
          "__v": 0
        },
        {
          "_id": "64e324ae144676734ea716fd",
          "title": "Address by GS Season 2",
          "description": "<p class=\"x_MsoNormal\"><strong>SOMETHING THIS GOOD DESERVES A SECOND ROUND</strong></p>\r\n<p class=\"x_MsoNormal\">#LIKENOOTHER</p>\r\n<p class=\"x_MsoNormal\">The Address by GS Season 2 is your exclusive world of thoughtful amenities, elegant craftsmanship and fine design. Luxury and modernity combine seamlessly to create a living experience Like No Other. This exclusive, upscale community is&nbsp;my ode to elevated living, curated&nbsp;exclusively for you. It is designed for those who demand the best of everything life has to offer. You are invited to enjoy my signature lifestyle as true connoisseurs of class.</p>\r\n<p class=\"x_MsoNormal\">The Address by GS Season 2, is a place of sophistication that you can call your own. Life here elevates your everyday into the realm of extraordinary. Live amidst posh neighbourhoods, high-end glitzy malls, reputed educational institutions, world-class healthcare. Inside, experience the quiet joys of an exquisite gated community life. Safe, secure with upwardly mobile socialites who match your aspirations. From the ground, podium or to the Clubhouse, you can design your lifestyle for unmatched contentment. Be pampered by recreational amenities that rival the best the city has to offer. Roman-inspired landscapes, a modern and exclusive clubhouse, experience elevated living at its best.&nbsp;</p>\r\n<p>&nbsp;</p>",
          "image": "1692607662669address by gs_1.jpg",
          "website": "https://raymondrealty.in/the-address-by-gs-season-2",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 4,
          "createdAt": "2023-08-21T08:47:42.718Z",
          "updatedAt": "2023-08-21T08:47:42.718Z",
          "__v": 0
        },
        {
          "_id": "64e325f0144676734ea7182a",
          "title": "Invictus By GS ",
          "description": "<p><strong>Reimagining Power Living</strong></p>\r\n<p>An odyssey for a handful, Invictus by GS presents curated opulence. These super-premium residences invite ambitious visionaries to live limitless. Come, embrace a lifestyle of a different altitude and continue your relentless pursuit of excellence.</p>\r\n<p>A salute to the excellence that sets the few apart from the many. An abode for those who continuously raise the bar. Trailblazers who inspire and show the way to reach a new altitude. At Raymond Realty, experience power living at its finest.</p>",
          "image": "1692607984329Invictus.jpg",
          "website": "https://raymondrealty.in/invictus-by-gs",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 5,
          "createdAt": "2023-08-21T08:53:04.381Z",
          "updatedAt": "2023-08-21T08:53:42.952Z",
          "__v": 0
        },
        {
          "_id": "65d71d5002cabaca5cff7300",
          "title": "The Address by GS - Bandra",
          "description": "<p>Bandra is like a blend of charming Portuguese-style architecture in cozy corners and luxurious sea-facing apartments. It caters to both the glitz of movie stars and the hustle of corporate elites, featuring world-class brands, chic malls, diverse dining options, vibrant nightlife, and high-end fashion. Bandra, the Queen of Mumbai, is where Global and Mumbai vibes meet.<br /><br />Living the Bandra life elevates you to a pinnacle, setting unparalleled standards in Mumbai. It's a lifestyle that craves a home to complement it, and that's where the signature style of Mr. Gautam Singhania, Chairman of the Raymond Group, steps in with The Address by GS &mdash; Bandra's finest gated community. Taking cues from Portuguese heritage, creating a modern living space that will make you rethink what a queen's abode should look like.</p>",
          "image": "1708597176589address by gs bandra.jpg",
          "website": "https://raymondrealty.in/2-3-4-bhk-in-bandra",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62c08e71838e7c12e3b2c81c",
          "sort_order": 6,
          "createdAt": "2024-02-22T10:09:20.053Z",
          "updatedAt": "2024-02-22T10:19:36.650Z",
          "__v": 0
        }
      ]
    },
    {
      "_id": "62dffdcb31855c49188ddfeb",
      "title": "Engineering(Tools, Auto and Aerospace)",
      "slug": "jk-files-engineering",
      "description": "<p>&lrm;</p>",
      "image": "1659511375549Pithampur (1)-min.png",
      "sort_order": 3,
      "createdAt": "2022-07-26T14:44:27.484Z",
      "updatedAt": "2023-12-08T10:19:48.585Z",
      "__v": 0,
      "brands": [
        {
          "_id": "62e0054d9fe9a117cb3ce9cc",
          "title": "JK Engineering",
          "description": "<p><span style=\"font-weight: 400;\">JK Files &amp; Engineering Limited, a subsidiary of Raymond Ltd, is the world's largest manufacturer of steel files with a presence in 55+ countries. With trusted relationships that are built over the past seven decades, JK Files &amp; Engineering has earned a reputation for offering an expansive and versatile range of custom-made files and tools as per BS, FS, ISI and DIN standards or as specified by customers. The company also has a strong presence in the Asian, African and Latin American regions and is the largest brand in the African market. In addition, it is amongst the known players in the drills segment in India.</span></p>\r\n<p>&nbsp;</p>\r\n<p><span style=\"font-weight: 400;\">JK Files &amp; Engineering is involved in the manufacturing and sale of precision engineered components for tools and hardware such as steel files, drills, hand tools and powerful tool </span><span style=\"font-weight: 400;\">accessories as well as auto components such as ring gears, flexplates and water pump</span></p>\r\n<p><span style=\"font-weight: 400;\">bearings. It has futuristic manufacturing ISO 9001-2015 certified plants in Ratnagiri &amp; Chiplun (Maharashtra), Pithampur (Madhya Pradesh) and Vapi (Gujarat) and is equipped with in-house rolling mills that ensure premium quality as well as easy product availability.&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">The brand &lsquo;JK Superdrive&rsquo; extends JK Files' rich legacy of technological know-how and expertise in manufacturing files and Drills to quality products in Hand Tools and Power Tools categories. The expansive portfolio includes a wide variety of handheld electric-powered and non-powered tools. JK Superdrive has a resilient supply chain and a pan-India distribution network consisting of over 730 active distributors with a retail reach of over 150,000 outlets spanning over 600 towns in India. While JK Superdrive represents domestic markets, Three Files represents JK Files Latin America and African countries, and Sunflower is a leading Files brand in MEA and ASIAN markets.</span></p>\r\n<p><span style=\"font-weight: 400;\">&nbsp;</span></p>\r\n<p><span style=\"font-weight: 400;\">For detailed information and the range of each category, please visit our website.</span></p>",
          "image": "1663675211738Jk engineering.jpg",
          "website": "https://www.jkfilesandengineering.com/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62dffdcb31855c49188ddfeb",
          "sort_order": 1,
          "createdAt": "2022-07-26T15:16:29.513Z",
          "updatedAt": "2023-12-08T10:33:12.825Z",
          "__v": 0
        },
        {
          "_id": "6308c5991d7fb152e7de79ad",
          "title": "Ring Plus Aqua Ltd",
          "description": "<p>In 1984, Raymond forayed into the Automotive Components via Ring Plus Aqua Ltd- a prominent Ring Gear, Water Pump Bearings and Flexplate manufacturer in India. Equipped with state-of-the-art infrastructure and certified with ISO/TS 16949 Quality System, RPAL offers a strong value proposition in the industry. It has a market leadership position in Ring Gears with a volume share of more than 50% in Passenger Vehicles and more than 45% in Commercial Vehicles in India in Fiscal 2021.</p>\r\n<p>With its operation base in Nashik and Corporate Office In Mumbai, RPAL has a long celebrated history with the global auto &amp; non-auto industry. It is the sole domestic manufacturer of flexplates in India and caters to over 25% of the flexplates volume demand for PV domestic production in Fiscal 2021. We focus on producing products that exceed customer expectations with an emphasis on OTIF (On Time In Full), Reliable Quality and cater to the JIT (Just-in-time) needs through our warehouses in Canada, the United States &amp; Germany. RPAL has an annual production capacity of 8.2 million pieces for Ring Gears, 3.9 million pieces for Water Pump Bearings and 0.62 million pieces for Flexplates.</p>",
          "image": "1663823147678Ring plus aqua.jpg",
          "website": "https://ringplusaqua.com",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62dffdcb31855c49188ddfeb",
          "sort_order": 2,
          "createdAt": "2022-08-26T13:07:37.496Z",
          "updatedAt": "2022-09-22T05:05:47.862Z",
          "__v": 0
        },
        {
          "_id": "6308c5991d7fb152e7de79ad",
          "title": "MPPL",
          "description": "<p>MPPL is an end-to-end solutions provider engaged in process design, engineering, manufacturing, testing, and supply of a variety of precision products and assemblies.They are capable of diverse and critical manufacturing and finishing processes, including machined castings, die castings, machined forgings, bar route machining, plate machining, surface treatment, heat treatment, critical assembly, as well as ancillary activities such as end of line testing, export packing and warehousing, which helps us provide end-to-end solutions for our customer requirements.</p>",
          "image": "https://oneraymond.in/media/MPPL.jpg",
          "website": "https://www.mainiprecisionproducts.com/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62dffdcb31855c49188ddfeb",
          "sort_order": 2,
          "createdAt": "2022-08-26T13:07:37.496Z",
          "updatedAt": "2022-09-22T05:05:47.862Z",
          "__v": 0
        }
      ]
    },
    {
      "_id": "62fd29481d7fb152e7de4d9d",
      "title": "Denim",
      "slug": "denim",
      "description": "<p><span style=\"font-weight: 400;\">A formidable player in the denim category, Raymond is amongst the leading producer &amp; preferred suppliers of high-quality Ring Denim to the world&rsquo;s renowned Jeanswear Brands</span><strong>.</strong></p>",
      "image": "16608031889341656857592727UCO Denim (1).jpg",
      "sort_order": 5,
      "createdAt": "2022-08-17T17:45:44.544Z",
      "updatedAt": "2022-08-18T06:13:08.993Z",
      "__v": 0,
      "brands": [
        {
          "_id": "62fd29831d7fb152e7de4da3",
          "title": "Raymond UCO",
          "description": "<p><span style=\"font-weight: 400;\">Raymond UCO Denim Private Limited is a preferred supplier of the finest quality denim fabrics </span><span style=\"font-weight: 400;\">and apparel in the world. The company&rsquo;s strength lies in producing fabrics comprising&nbsp; </span><span style=\"font-weight: 400;\">premium cotton, stretch, exotic blends, special finishes and performance denim, amongst </span><span style=\"font-weight: 400;\">others. The denim fabric manufacturing facilities are located in Yavatmal (Maharashtra) and Romania (Europe), having an aggregated annual manufacturing capacity of 47 million metres. The business caters to customers across America, Europe, Asia as well as domestic markets. Having earned the respect of leading brands in domestic as well as international markets, Raymond UCO Denim meets the growing demands of fashion-conscious customers.</span></p>",
          "image": "1661760917776Raymond UCO.jpg",
          "website": "https://raymonddenim.com/",
          "pintrest": "",
          "facebook": "",
          "linkedin": "",
          "youtube": "",
          "twitter": "",
          "instagram": "",
          "status": 1,
          "brandCategory": "62fd29481d7fb152e7de4d9d",
          "sort_order": null,
          "createdAt": "2022-08-17T17:46:43.799Z",
          "updatedAt": "2023-08-28T12:19:17.806Z",
          "__v": 0
        }
      ]
    }
  ]
  const ourBrandTabList = BD?.map(({ title }, i) => (
    <span
      key={i}
      onClick={() => setOurBrandIndex(i)}
      className={`brand_tab ${parseInt(ourBrandIndex) === i ? "active" : ""}`}
    >
      {title}
    </span>
  ));
  const mbOurBrandTabList = BD?.map(({ title }, i) => (
    <option value={title} key={i} data-brandindexid={i}>
      {title}
    </option>
  ));



  // let newbranddata = []
  // if (brandsDataArr) {
  //   newbranddata = brandsDataArr?.slice(1, 4)
  // }
  const ourBrandsSwiperList = BD.length && BD.map((brandData, i) => (
    <Swiper
      className={`our_brand_swiper ${parseInt(ourBrandIndex) === i ? "active" : ""
        }`}
      key={i}
      // loop={brandData.brands.length > 3 ? true : false}
      modules={[Navigation, Autoplay]}
      navigation={{
        prevEl: `.our_brands_swiper_wrapper .left_btn_${i}`,
        nextEl: `.our_brands_swiper_wrapper .navigation_wrapper_next_${i}`,
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      breakpoints={{
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        330: {
          slidesPerView: 1.3,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2.1,
        },
        992: {
          slidesPerView: 2.5,
        },
        1194: {
          slidesPerView: 3,
        },
        1921: {
          slidesPerView: 3.4,
          spaceBetween: 0,
        },
      }}
    >
      {brandData.brands.map(({ image, _id }, i) => (
        <SwiperSlide key={i}>
          <Link to={`/our-brand/${brandData.slug}`} state={{ boxId: _id }}>
            <div className="brand_box">
              <img
                src={image == 'https://oneraymond.in/media/MPPL.jpg' ? 'https://oneraymond.in/media/MPPL.jpg' : brandImageUrl + image}
                alt="Brand img"
                className="brandimg"
                loading="lazy"
                width={366}
                height={361}
              />
              <HoverRightArrow className="brand_hover_right_arrow" />
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  ));
  const newsAndMediaList = mediaData?.map(
    ({ bgImage, name, description, slug, template, url }, i) => (
      <SwiperSlide key={i}>
        {template !== "external" ? (
          <Link to={`/newsroom/news-and-media/${slug}`}>
            <div className="news_box">
              <img
                src={bgImage}
                alt="Our news"
                loading="lazy"
                width={413}
                height={384}
                className="newsimg"
              />
              <div className="text_container">
                <HoverRightArrow className="circle_right_arrow" />
                <h5 className="new_box_title">{name.toLowerCase()}</h5>
                <p className="desc">{description}</p>
              </div>
            </div>
          </Link>
        ) : (
          <a href={url} target="_blank" rel="noreferrer">
            <div className="news_box">
              <img
                src={bgImage}
                alt="Our news"
                loading="lazy"
                width={413}
                height={384}
                className="newsimg"
              />
              <div className="text_container">
                <HoverRightArrow className="circle_right_arrow" />
                <h5 className="new_box_title">{name.toLowerCase()}</h5>
                <p className="desc">{description}</p>
              </div>
            </div>
          </a>
        )}
      </SwiperSlide>
    )
  );
  const sus = [
   
    {
      "_id": "62bf1a8c838e7c12e3b2c582",
      "title": "Education",
      "slug": "education",
      "description": "<p><span style=\"font-weight: 400;\">The Raymond Group endeavours to uplift the community at large with a vision for high-quality education that meets the educational requirements of today&rsquo;s children by imparting the necessary skills and knowledge.</span></p>",
      "image": "1656691339770banner (7).jpg",
      "category": "CSR",
      "status": 1,
      "createdAt": "2022-07-01T16:02:20.385Z",
      "updatedAt": "2022-12-23T06:32:02.172Z",
      "__v": 0
    },
  ]
  const susList = sus?.map(({ image, title, slug }, i) => (
    <SwiperSlide key={i}>
      <Link to={`/beyond-business/csr/${slug}`}>
        <div className="sus_box">
          <img
            src={susBlocksImageUrl + image}
            alt="Sustainability"
            loading="lazy"
            width={384}
            height={379}
            className="susimg"
          />
          <HoverRightArrow className="circle_right_arrow" />
          <h5 className="sus_box_title">{title.toLowerCase()}</h5>
        </div>
      </Link>
    </SwiperSlide>
  ));

  if (
    isSliderLoading ||
    isOurBusinessLoading ||
    isOurBrandsLoading ||
    isMediaLoading ||
    isSusLoading
  ) {
    return <Loader />;
  }

  businessData = (businessData.data.data).slice(1, 4)
  return (
    <>
      <MetaDecorator metaTitle="Welcome to Raymond | Home" />
      <section className="homesec1" ref={bannerEl}>
        <div className="my_container">
          <div className="row">
            <div className="col-lg-12 col1">
              <h1 className="banner_heading">
                <span className="outer_span">
                  <span className="inner_span inner_span1">Trust,</span>
                </span>{" "}
                <span className="outer_span">
                  <span className="inner_span inner_span2 redbg">Quality,</span>
                </span>{" "}
                <br />{" "}
                <span className="outer_span">
                  <span className="inner_span inner_span3">Excellence.</span>
                </span>{" "}
              </h1>
              <p className="banner_desc_style" data-aos="fade-up">
                Raymond Ltd is involved in numerous businesses and has a portfolio of well-known brands in Textiles, Apparel, Denim, Engineering, and Real Estate.
              </p>
            </div>

          </div>
        </div>

        {width >= 600 ?
          <div className="socialmedia_float_icon">
            <ul className="media_icons_wrapper custom-li">
              <li>
                <a
                  href="https://in.linkedin.com/company/raymond-limited"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  <Linkgrey className="banner_social_icons" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/raymond_the_complete_man/?hl=en"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  <Instagrey className="banner_social_icons" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/RaymondLimited/"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  <Fbgrey className="banner_social_icons" />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/theraymondltd?lang=en"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  <Twiitergrey className="banner_social_icons" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/user/raymondlimited"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  <Youtubegrey className="banner_social_icons" />
                </a>
              </li>
              <li>
                <a
                  href="https://in.pinterest.com/Raymond_corp/?eq=raymond%20ltd&etslf=6757"
                  target="_blank"
                  rel="noreferrer"
                  className="social_icon_wrapper"
                >
                  {/* <Pintrstgrey className="banner_social_icons" /> */}
                  <img src={pintrst} alt="" className="banner_social_icons" />
                </a>
              </li>
            </ul>
          </div>
          : ""}

        {/* <div className={width <= 1279 ? "my_container" : ""}> */}
        <div className="my_container">
          <div className="banner_slides_wrapper">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={20}
              pagination={{
                el: ".my-custom-pagination-div",
                clickable: true,
                renderBullet: (index, className) => {
                  return '<span class="' + className + '">' + "" + "</span>";
                },
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
            // loop={true}
            >
              {bannerImgList[0]}
            </Swiper>
            <div class="my-custom-pagination-div" />
          </div>
        </div>
      </section>

      <section className="homesec2 extra_space_issue" data-aos="fade-up">
        <div className="row m-0">
          <div className="col-lg-6 col1">
            <h5 className="section_name">About Us</h5>
            <h2 className="section_title">
              Raymond, A Diversified Group Shaping A Stronger & Better Tomorrow.
            </h2>
            <p className="desc_text">
              With roots dating back to 1925, as a small woollen mill in Thane
              (Maharashtra), manufacturing coarse woollen blankets, Raymond
              Brand has evolved into a leading manufacturer of the finest
              fabrics in the world. Reckoned for its pioneering innovations and
              having enjoyed the patronage of millions of consumers, Raymond is
              amongst the trusted brands in India.
            </p>
            {/* <p className="section_desc">
              With an eclectic portfolio of brands in the menswear space,
              Raymond Apparel has brands such as Raymond Ready to Wear, Park
              Avenue, ColorPlus, Parx and, Ethnix by Raymond.
              <br />
              <br />
              Being a vertically and horizontally integrated manufacturer of
              textiles, Raymond has strong fibre-to-fabric manufacturing
              capabilities and is a textile powerhouse with state-of-the-art
              modern infrastructure. Raymond offers an exquisite range of
              shirting and suiting fabrics across a plethora of options such as
              Worsted fabrics, Cotton, Wool blends, Linen and Denim. With over
              1500 stores spread across 600 towns and an expansive network of
              over 20,000 points of sale in India, Raymond and its brands are
              also available in tier IV & V cities. Over the years, the brand
              has emerged as a preferred choice for top design houses globally.
              Raymond has also been a leading player in High-value cotton
              shirting fabrics and is the No. 1 brand in the OTC space.
              <br />
              <br />
              Raymond Group also has a significant presence in the B2B space
              through its garmenting business. Our state-of-the-art & wholly
              owned subsidiaries such as Silver Spark Apparel Ltd, Celebrations
              Apparel Ltd & Everblue Apparel Ltd craft suits, trousers, shirts &
              Jeans for leading fashion labels across the world and is the only
              manufacturer of full canvas premium jackets in India.
              <br />
              <br />A formidable player in the Denim category, Raymond is among
              the leading producer & preferred suppliers of high-quality Ring
              Denim to the world’s renowned Denim brands. Having established its
              dominance in Textiles, Raymond pioneered the innovative concept of
              customised clothing, ‘Raymond Made To Measure’ that offers
              luxurious service to discerning customers to personalize their
              ensemble. The Raymond Group has a strong presence in the Consumer
              Care space via Raymond Consumer Care. The company mainly caters to
              the male grooming segment in fragrances, soaps and shampoos
              through the Park Avenue brand. The Consumer Care business also has
              a strong positioning in the sexual wellness segment through its
              KamaSutra brand.
              <br />
              <br />
              Raymond Ltd. ventured into the engineering business in 1949. JK
              Files and Engineering Ltd. enjoys a leadership position as the
              world’s largest manufacturer of steel files with a share of over
              25% of global capacity in 2020, with a presence in over 55
              countries. It is a market leader in the file segment in India with
              a market share of over 60% by sales volume in Fiscal 2021. Through
              its Group Company Ring Plus Aqua Ltd (RPAL), it is in the
              manufacturing, sale and distribution of auto components and
              engineering products such as Ring Gears, Flexplates and Water pump
              bearings. RPAL has the market leadership position in Ring Gears
              with a volume share of more than 50% in Passenger Vehicles and
              more than 45% in Commercial Vehicles in India in Fiscal 2021. In
              Flexplates, RPAL is the sole domestic manufacturer in India.
              <br />
              <br />
              Recently, Raymond Group forayed into the real estate development
              business. With the central theme of <strong>‘Go Beyond’</strong>,
              the company has undertaken the project to build quality housing
              for all. A large gated community named{" "}
              <strong>‘Aspirational District’</strong> is spread over 14 acres
              that celebrate a new epoch in living.
            </p> */}
            <div className="btn_wrapper">
              <RightArrowButton
                linkTo="/our-company/about-us"
                ctaText="know more"
              />
            </div>
          </div>
          <div className="col-lg-6 col2">
            <img
              src={'https://oneraymond.in/media/aboutusbelowbanner.jpg'}
              alt="Our company"
              loading="lazy"
              width="622"
              height="704"
              className="our_company_img"
            />
            <div className="experience_box">
              <img
                src={aboutSmallimg}
                alt="Our company"
                loading="lazy"
                width="237"
                height="222"
                className="exp_img"
              />
              <div className="exp_text_wrapper">
                <span className="exp_no">Since</span>
                <span className="exp_text section_desc">1925</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="homesec3" data-aos="fade-up">
        <div className="re_imagine_flex">
          <figure className="re_imagine_left_wrapper">
            <img
              src={directorimage}
              alt="Raymond reimagine"
              className="re_imagine_left_img"
              loading="lazy"
              width={814}
              height={618}
            />
          </figure>
          <div className="re_imagine_content_wrapper">
            <img
              src={quoteComma}
              alt="Quote img"
              loading="lazy"
              className="quote_img"
            />
            <p className="re_imagine_para">
              The future lies in imagining the unimaginable! At Re-imagined
              Raymond, we aspire to achieve just the same. We aim to create not
              just offerings but an organisation that is built for the future.
            </p>
            <div className="re_imagine_quote_owner_details">
              <span>Gautam Hari Singhania</span>
              <span>Chairman & Managing Director</span>
              <span>Raymond Ltd.</span>
            </div>
            <div className="btn_wrapper">
              <RightArrowButton
                linkTo="/our-company/raymond-re-imagined"
                ctaText="read more"
                ctaWhite
              />
            </div>
          </div>
        </div>
      </section>

      <section className="homesec4" data-aos="fade-up">
        <h5 className="section_name">our Businesses</h5>
        <div className="row title_desc_wrapper">
          <div className="col-md-6 p-0">
            <h2 className="section_title">Our Quest For Excellence</h2>
          </div>
          <div className="col-md-6 p-0">
            <p className="section_desc">
              At the soul of Raymond resides the quest to delight our consumers
              with our high-quality offerings and pioneering innovations.
            </p>
          </div>
        </div>
        <div className="our_business_slider_wrapper">
          {/* <Swiper
            modules={[Navigation, Autoplay, FreeMode]}
            navigation={{
              prevEl: ".our_business_slider_wrapper .left_btn",
              nextEl: ".our_business_slider_wrapper .right_btn",
            }}
            speed={900}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={false}
            breakpoints={ourBusinessBreakpoints}
          >
         {ourBusinessList.slice(1, 4)}
        </Swiper> */}
          <div style={{ overflow: "auto" }}>
            <div className="business-container" style={{ display: "flex", gap: "10px", width: "100%", padding: "5px" }}>
              {
                businessData.map(
                  ({ title, image, _id, website }, i) => (
                    <div key={i} >
                      <Link to={website} state={{ boxId: _id }}>
                        <div className="business_box" style={{ width: "425px" }}>
                          <img
                            src={businessImageUrl + image}
                            alt="Our business"
                            loading="lazy"
                            width={625}
                            height={415}
                            className="businessimg"
                          />
                          <HoverRightArrow className="circle_right_arrow" />
                          <span className="business_text">{title}</span>
                        </div>
                      </Link>
                    </div>
                  )
                )
              }
            </div>
          </div>
          {/* <div className="navigation_wrapper">
            <div className="left_btn">
              <LeftArrowButton normalCta ctaText="previous" />
            </div>
            <div className="right_btn">
              <RightArrowButton normalCta ctaText="next" />
            </div>
          </div> */}
        </div>
      </section>

      <section className="homesec5" data-aos="fade-up">
        <h5 className="section_name">Our BRands</h5>
        <h2 className="section_title">
          Raymond has a portfolio of iconic brands across business verticals
        </h2>
        {width <= 767 ? (
          <div className="mb_brand_tabs_dropdown_wrapper">
            <select
              onChange={handleBrandTabChange}
              className="mb_brands_dropdown"
            >
              {mbOurBrandTabList}
            </select>
            <img
              src={selectdropdownarrow}
              alt="dropdown arrow"
              loading="lazy"
              className="selectdropdownarrow"
            />
          </div>
        ) : (
          <div className="brands_tabs_wrapper">{ourBrandTabList}</div>
        )}
        <div className="our_brands_swiper_wrapper">
          {ourBrandsSwiperList}
          {/* <div className="navigation_wrapper navigation_wrapper_next">
            <RightArrowButton normalCta ctaText="next" ctaWhite />
          </div> */}
          {width <= 767
            ? BD?.map(
              (brandData, i) =>
                brandData?.brands?.length > 1 && (
                  <div
                    className={`navigation_wrapper mb_navigation_wrapper ${parseInt(ourBrandIndex) === i ? "active" : ""
                      }`}
                    key={i}
                  >
                    <div className={`left_btn left_btn_${i}`}>
                      <LeftArrowButton
                        normalCta
                        ctaText="previous"
                        ctaWhite
                      />
                    </div>
                    <div className={`right_btn navigation_wrapper_next_${i}`}>
                      <RightArrowButton normalCta ctaText="next" ctaWhite />
                    </div>
                  </div>
                )
            )
            : BD?.map(
              (brandData, i) =>
                brandData.brands?.length > 3 && (
                  <div
                    className={`navigation_wrapper navigation_wrapper_next navigation_wrapper_next_${i} ${parseInt(ourBrandIndex) === i ? "active" : ""
                      }`}
                    key={i}
                  >
                    <RightArrowButton normalCta ctaText="next" ctaWhite />
                  </div>
                )
            )}
        </div>
      </section>

      <section className="homesec6" data-aos="fade-up">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5 p-0">
              <h5 className="section_name">News Center</h5>
              <h2 className="section_title">News & Media</h2>
              <p className="section_desc">
                What’s happening at Raymond? Read our latest news stories
                encompassing latest business updates.
              </p>
              <div className="btn_wrapper">
                <RightArrowButton
                  linkTo="/newsroom/news-and-media"
                  ctaText="know more"
                />
              </div>
            </div>
            <div className="col-md-7 col2 p-0">
              <div className="news_swiper_wrapper">
                <Swiper
                  modules={[Navigation]}
                  navigation={{
                    prevEl: ".news_swiper_wrapper .left_btn",
                    nextEl: ".news_swiper_wrapper .right_btn",
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    767: {
                      slidesPerView: 1.5,
                      spaceBetween: 0,
                    },
                    992: {
                      slidesPerView: 2,
                    },
                    1930: {
                      slidesPerView: 2.4,
                    },
                  }}
                >
                  {newsAndMediaList}
                </Swiper>
                <div className="navigation_wrapper">
                  <div className="left_btn">
                    <LeftArrowButton normalCta ctaText="previous" />
                  </div>
                  <div className="right_btn">
                    <RightArrowButton normalCta ctaText="next" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="homesec7" data-aos="fade-up">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5 col2 order-md-2">
              <h5 className="section_name">Investors</h5>
              <h2 className="section_title">Investor Relations</h2>
              <p className="section_desc">
                We uphold transparency with our investors by sharing
                developments on our strategic initiatives and financial results
                with timely communication that enables them to make informed
                decisions.
              </p>
              <div className="btn_wrapper">
                <RightArrowButton
                  ctaText="Know More"
                  linkTo="/investor/disclosures-under-regulation-46-of-the-lodr/corporate-governance"
                />
              </div>
            </div>
            <div className="col-md-7 col1 order-md-1 stock_wrapper">
              <img
                src={investorGraph}
                alt="Investor relations graph"
                className="investordummyimg"
              />
              <div className="stock_price">
                ₹ {Math.round(stock.pricecurrent)}{" "}
                <span>
                  {Math.sign(parseInt(stock.pricepercentchange)) > 0 ? (
                    <img
                      className="updown_arrow"
                      alt="down arrow stock"
                      src={stockup}
                    />
                  ) : (
                    <img
                      className="updown_arrow"
                      alt="down arrow stock"
                      src={stockdown}
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="homesec8" data-aos="fade-up">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 col1">
              <h5 className="section_name">Beyond Business</h5>
              <h2 className="section_title">Beyond Business</h2>
              <p className="section_desc">
                Raymond Group is committed to building a purpose-led future and
                being a socially responsible corporate citizen. Through its
                various social initiatives, Raymond strives to create
                opportunities for all that will empower them to rise to their
                fullest potential.
              </p>
              {width > 767 && (
                <div className="navigation_wrapper">
                  <div className="left_btn">
                    <LeftArrowButton normalCta ctaText="previous" />
                  </div>
                  <div className="right_btn">
                    <RightArrowButton normalCta ctaText="next" />
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-8 col2">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: ".homesec8 .left_btn",
                  nextEl: ".homesec8 .right_btn",
                }}
                breakpoints={sustainabilityBreakpoints}
              >
                {susList}
              </Swiper>
              {width <= 767 && (
                <div className="navigation_wrapper">
                  <div className="left_btn">
                    <LeftArrowButton normalCta ctaText="previous" />
                  </div>
                  <div className="right_btn">
                    <RightArrowButton normalCta ctaText="next" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {instapost.length > 0 && (
        <section className="homesec9" data-aos="fade-up">
          <div className="text_container">
            <h5 className="section_name">Our Social Presence</h5>
            <h2 className="section_title">Life @Raymond on Instagram</h2>
          </div>
          <div className="insta_swiper_wrapper">
            <Swiper
              modules={[Navigation]}
              navigation={{
                prevEl: ".insta_swiper_wrapper .left_btn",
                nextEl: ".insta_swiper_wrapper .right_btn",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                340: {
                  slidesPerView: 1.1,
                },
                530: {
                  slidesPerView: 1.6,
                },
                767: {
                  slidesPerView: 2.5,
                },
                1020: {
                  slidesPerView: 3,
                },
              }}
            >
              {/* <SwiperSlide>
              <img
                src={instaimg1}
                alt="Insta img"
                className="instaimg"
                loading="lazy"
                width={450}
                height={450}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={instaimg2}
                alt="Insta img"
                className="instaimg"
                loading="lazy"
                width={450}
                height={450}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={instaimg1}
                alt="Insta img"
                className="instaimg"
                loading="lazy"
                width={450}
                height={450}
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={instaimg2}
                alt="Insta img"
                className="instaimg"
                loading="lazy"
                width={450}
                height={450}
              />
            </SwiperSlide> */}
              {instapostlist}
            </Swiper>
            <div className="navigation_wrapper">
              <div className="left_btn">
                <LeftArrowButton normalCta ctaText="previous" />
              </div>
              <div className="right_btn">
                <RightArrowButton normalCta ctaText="next" />
              </div>
            </div>
          </div>
        </section>
      )}
      <FsLightbox toggler={isVideoModalOpen} sources={[vidLink]} />

      {/* <div className="dummy"></div> */}
    </>
  );
};

export default Homepage;
